import Link from "next/link";
import React from "react";
import { ELEMENTS } from "../../utils";
import retailerOptions from "./retailer-options";
import AmazonRetailerMessage from "./amazon-retailer-message";

const MessageBody = () => {
  return (
    <span>
      We can only offer price promise refunds for items which meet our&nbsp;
      <Link href="/prices-and-payment/price-promise#terms-conditions" rel="noopener noreferrer" target="_blank">
        terms and conditions
      </Link>
      .
    </span>
  );
};

const QualifyingList = () => {
  return (
    <div>
      <ul>
        <li>It’s identical, including the same make, colour, size and specification.</li>
        <li>It’s in stock and ready for delivery.</li>
        <li>
          Did you buy the item from John Lewis in the last 7 days? This must be the date you placed the order or bought
          it from us, not the date it was delivered/collected.
        </li>
        <li>
          It’s not sold by a marketplace or 3rd party seller on the retailer’s platform.{" "}
          <Link
            href={`https://www.johnlewis.com/customer-services/faq/How-to-check-if-an-item-is-sold-directly-or-by-a-240924090908830`}
            rel="noopener noreferrer"
            target="_blank"
          >
            How to check items are sold by 3rd parties.
          </Link>
        </li>
        <li>
          It can be on a seasonal offer or promotion. But we do not price match: reduced to clear items, multi-buys,
          member-only prices, flash sales, promo codes, or exclusive/trade prices.
        </li>
      </ul>
      <p>
        <Link href="/prices-and-payment/price-promise#terms-conditions" rel="noopener noreferrer" target="_blank">
          See full terms and conditions
        </Link>
      </p>
    </div>
  );
};

const qualifySectionElements = {
  id: ELEMENTS.PURCHASE_SECTION,
  title: "Check you qualify",
  type: "section",
  description: () => {},
  elements: [
    {
      id: ELEMENTS.CHECK_QUALIFY,
      type: "radio",
      options: [
        { value: "yes", label: "Yes, it qualifies" },
        { value: "no", label: "No" },
      ],
      inlineOptions: true,
      title: "Does the lower price item you’ve found qualify?",
      description: () => <QualifyingList />,
    },
    {
      id: ELEMENTS.CHECK_QUALIFY_MESSAGE_BOX,
      type: "message",
      componentProps: {
        type: "error",
        title: "Sorry, we can’t offer you a price match",
        body: React.createElement(MessageBody),
        role: "alert",
        wideTab: true,
        whiteBackground: true,
      },
    },
    {
      id: ELEMENTS.LOWER_PRICE_RETAILER,
      type: "select",
      title: "Where did you find the lower price?",
      description:
        "We only price match with the retailers on this list. We do not price match 3rd party sellers on their websites.",
      options: [{ value: "", label: "Select a retailer" }, ...retailerOptions],
    },
    {
      id: ELEMENTS.INFO_RETAILER_MESSAGE,
      type: "message",
      componentProps: {
        type: "information",
        title: "We need some more information for your request",
        body: "Thanks for confirming the retailer. To check if you’re eligible for a refund, we need a few more details.",
        role: "info",
        whiteBackground: true,
      },
    },
    {
      id: ELEMENTS.WARN_AMAZON_RETAILER_MESSAGE,
      type: "message",
      componentProps: {
        type: "warning",
        title: "Please check it’s sold directly by Amazon before continuing",
        body: AmazonRetailerMessage(),
        role: "info",
        whiteBackground: true,
      },
    },
    {
      id: ELEMENTS.WARN_JOHN_LEWIS_RETAILER_MESSAGE,
      type: "message",
      componentProps: {
        type: "warning",
        title: "Please check the item isn't reduced to clear",
        body: "We'll price match some offers and promotions but not reduced to clear",
        role: "info",
        whiteBackground: true,
      },
    },
  ],
};

export default qualifySectionElements;
